import { createApp } from 'vue'
import axios from 'axios'
import helpers from './mixins/helpers'
import router from './router'
import { createPinia } from 'pinia'
import mitt from 'mitt'
import { vfmPlugin } from 'vue-final-modal'
import VueFlatPickr from 'vue-flatpickr-component'
import Toaster from '@meforma/vue-toaster'
import '../../../node_modules/select2/dist/js/select2.full'
import '../../../node_modules/select2/dist/css/select2.min.css'
import OptimizeFlowApp from './components/Flow.vue'

class OptimizeFlow {
    /**
     * Init OptimizeFlow app
     */
    constructor() {
        this.$         = jQuery
        this.debug     = true
        this.app       = null
        this.router    = null
        this.selector  = '#op-flow-app'

        this._initApp()
    }
    
    /**OptimizeFlow
     * Init Vue.js app
     *
     * @private
     */
    _initApp() {
        this.$(() => {
            // Create new VueJS app
            this.app = createApp(OptimizeFlowApp)

            // Enable debugging
            this.app.config.devtools = this.debug

            // Assign OPP object for global access
            this.app.config.globalProperties.OptimizeFlow = window.OptimizeFlow

            // Assign window object for global access
            this.app.config.globalProperties.window = window

            // Add helpers
            this.app.mixin(helpers)

            // Add HTTP client
            this.app.config.globalProperties.$http = axios
            axios.interceptors.request.use(function (config) {
                document.body.classList.add('opfw-is-loading')
                // console.log("Loading...")
                return config
            }, function (error) {
                return Promise.reject(error)
            })
            axios.interceptors.response.use(function (response) {
                document.body.classList.remove('opfw-is-loading')
                // console.log("Done loading...")
                return response
            }, function (error) {
                document.body.classList.remove('opfw-is-loading')
                return Promise.reject(error)
            })

            // Set base URL
            axios.defaults.baseURL                      = window.OptimizeFlow.rest_url
            axios.defaults.headers.common['X-WP-Nonce'] = window.OptimizeFlow.nonce

            // Enable routing
            this.app.use(router)

            // Pinia store
            this.app.use(createPinia())

            // Popovers
            // this.app.component("Popper", Popper)

            // Add event bus
            this.app.config.globalProperties.$events = mitt()

            // Add modal support
            this.app.use(vfmPlugin({
                key: '$vfm',
                componentName: 'VueFinalModal',
                dynamicContainerName: 'ModalsContainer'
            }))

            // Add notification support
            this.app.use(Toaster)

            // Add FlatPickr (DatePicker)
            this.app.use(VueFlatPickr)

            // Register a global custom directive called `v-focus`
            this.app.directive('focus', {
                // When the bound element is mounted into the DOM...
                mounted(el) {
                    // Focus the element
                    el.focus()
                }
            })

            // Mount app and components
            router.isReady().then(() => {
                 this.app.mount(this.selector)
            })

            // Mark HTML element
            document.querySelector("html").classList.add("op-flow-root")
        })
    }
}


export default OptimizeFlow

window.OP3General.pages.optimizeFlow = new OptimizeFlow
